import getCustomCtaText from '@/utils/getCustomCtaText';
import { Button } from '@/components/DesignSystem/AtomicComponents';
import { IS_DESKTOP } from '@/utils/checkClientDeviceType.js';
import { ZeroOrder } from '@/assets/svgExports/ZeroOrder';
import {
  NoItemInOrderSection,
  NoItemInOrder,
  NoItemInOrderText,
} from '../order.styles.js';
import { getNoItemInOrderText, shopButtonClick } from '../tools.ts';
import { useSSRSelector } from '@/redux/ssrStore';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { OrderContext } from '../context/index.tsx';

export const NoItemView = () => {
  const router = useRouter();
  const { activeTab } = useContext(OrderContext);
  const { storeData, collections } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
    collections: state.catalogReducer.collections,
  }));

  return (
    <NoItemInOrder>
      <NoItemInOrderSection>
        <ZeroOrder height={IS_DESKTOP ? 222 : 162} width={IS_DESKTOP ? 222 : 162} />
        <NoItemInOrderText>{getNoItemInOrderText(activeTab)}</NoItemInOrderText>
      </NoItemInOrderSection>
      <Button
        px={IS_DESKTOP ? '75px' : '26px'}
        py="18px"
        fontColor="#ffffff"
        roundness={storeData?.theme?.roundness}
        backgroundColor={storeData?.theme?.colors?.primary_color}
        label={getCustomCtaText('banner_cta')}
        variant="solid"
        onClick={() => shopButtonClick({ collections, router, storeData })}
        fontSize={IS_DESKTOP ? 20 : 18}
      />
    </NoItemInOrder>
  );
};
